// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetFavoritesRecommendationsRequest,
  TGetFavoritesRecommendationsModel,
  IMappers,
  TGetFavoritesRecommendationsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFavoritesRecommendationsResponseSchema } from '../../entities/get_favorites_recommendations/GetFavoritesRecommendationsResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetFavoritesRecommendationsModel(
  parameters: TGetFavoritesRecommendationsRequest,
): TGetFavoritesRecommendationsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/get-favorites-recommendations/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetFavoritesRecommendationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetFavoritesRecommendationsRequest;
}

export async function fetchGetFavoritesRecommendations<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFavoritesRecommendationsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetFavoritesRecommendationsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetFavoritesRecommendationsModel(parameters),
    config,
  )) as FetchResponse<TGetFavoritesRecommendationsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFavoritesRecommendationsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetFavoritesRecommendationsResponse>;
}
